<template>
	<div>
		<!--面包屑导航区域-->
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-date"></i> 老师考勤导出
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" ref="query">
				<div class="handle-box">
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<!--搜索与添加-->
								<el-select v-model="query.valueSABSAAI" clearable filterable :placeholder="'请选择所属幼儿园'" class="handle-select mr10"
								 style="width: 15%;" @change="SABSAAIchange">
									<el-option v-for="item in query.optionsSBASAAI" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID">
									</el-option>
								</el-select>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<el-date-picker v-model="query.start" type="date" :picker-options="starttime" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
								 style="width: 14%;margin-right: 0.8%;" :placeholder="'开始时间'" />
								<span style="margin-right: 0.8%;">-</span>
								<el-date-picker v-model="query.end" type="date" :picker-options="endTime" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
								 style="width: 14%;" :placeholder="'结束时间'" />
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="22">
							<div class="grid-content bg-purple">
								<el-button type='primary' :disabled="!hasPerms(buttonPerms.exportPerms)" icon="el-icon-download" @click="handleSearch">导出Excel</el-button>
							</div>
						</el-col>
						<el-col :span="2">
							<div class="grid-content bg-purple-light">
							</div>
						</el-col>
					</el-row>
				</div>
			</el-form>
		</div>
	</div>
</template>
<script>
	import {
		hasPermission
	} from '@/permission/index.js'
	export default {
		name: 'attendanceList',
		inject: ['reload'], //在子组件中通过inject调用
		data() {
			return {
				//页面按钮权限
				buttonPerms: {
					exportPerms: 'signIn:attendanceList:export', //导出权限标识

					disabled: false
				},

				web_suuid: sessionStorage.getItem("ms_web_suuid"),
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户

				// 开始时间
				starttime: {
					disabledDate: time => {
						if (this.query.end) {
							return (
								time.getTime() > new Date(this.query.end).getTime()
							)
						} else {
							// 不能大于当前日期
							return time.getTime() > Date.now()
						}
					}
				},
				// 结束时间
				endTime: {
					disabledDate: time => {
						if (this.query.start) {
							return (
								time.getTime() > Date.now() ||
								time.getTime() < new Date(this.query.start).getTime() - 8.64e6
							)
						} else {
							return time.getTime() > Date.now()
						}
					}
				},
				query: {
					valueSABSAAI: '', //幼儿园名称
					optionsSBASAAI: [],
					start: new Date(new Date(new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/1').getTime()),
					end: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
				}
			};
		},
		created() {
			//获取幼儿园信息
			this.getSAA();
		},
		mounted() {
			this.$bus.$on('change', () => {
				//刷新当前页面
				this.reload()
			})
		},
		methods: {
			hasPerms: function(perms) {
				// 根据权限标识和外部指示状态进行权限判断
				return hasPermission(perms) & !this.buttonPerms.disabled
			},
			//时间格式化
			dateFormat: function(val) {
				var t = new Date(val); //row 表示一行数据, date 表示要格式化的字段名称
				var year = t.getFullYear(),
					month = t.getMonth() + 1,
					day = t.getDate(),
					hour = t.getHours(),
					min = t.getMinutes();
				var newTime = year + '-' +
					(month < 10 ? '0' + month : month) + '-' +
					(day < 10 ? '0' + day : day) + ' ' +
					(hour < 10 ? '0' + hour : hour) + ':' +
					(min < 10 ? '0' + min : min);
				return newTime;
			},
			/**
			 * @description 幼儿园选择事件
			 * 作者:魏强
			 * 作成时间:2020/11/30
			 * @return {void}
			 * */
			SABSAAIchange() {
				if (typeof(this.query.valueSABSAAI) !== 'undefined') {
					this.getSAD(this.query.valueSABSAAI);
				}
			},
			/**
			 * @description 获取幼儿园信息
			 * 作者:魏强
			 * 作成时间:2020/11/27
			 * @return {void}
			 * */
			getSAA() {
				const that = this;
				var postUrl = 'WCF/WEB/svcZAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
					}
				)
				.then((response) => {
					//请求成功返回的数据
					let resCount = response.data.KKDTCOUNT;
					if (resCount > 0) {
						this.query.optionsSBASAAI = response.data.KKDT;
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			/**
			 * @description 触发导出按钮
			 * 作者:魏强
			 * 作成时间:2021/02/03
			 * @return {void}
			 * */
			handleSearch() {
				let sSTARTDATE = this.query.start // + " 00:00:00";
				let sENDDATE = this.query.end // + " 23:59:59";

				if (this.query.valueSABSAAI.length == 0) {
					this.$alert('请选择幼儿园', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				}

				var time_s = new Date(this.dateFormat(this.query.start).replace(/-/g, '/')).getTime();
				var time_e = new Date(this.dateFormat(this.query.end).replace(/-/g, '/')).getTime();
				var nTime = time_e - time_s;
				var day = Math.floor(nTime / 86400000) + 1;

				if (day > 31) {
					this.$alert('请选的日期范围不能超过31天', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				}

				if (sSTARTDATE === null && sENDDATE !== null) {
					this.$alert('请选择登入时间', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				} else if (sSTARTDATE !== null && sENDDATE === null) {
					this.$alert('请选择登出时间', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				} else if (sSTARTDATE === null && sENDDATE === null) {
					this.$alert('请选择登入时间和登出时间', '提示', {
						confirmButtonText: '确定',
						callback: action => {}
					});
					return false;
				}
				
				this.getSignData();
	
			},
			/**
			 * @description 获取出勤数据
			 * 作者:魏强
			 * 作成时间:2020/11/27
			 * @return {void}
			 * */
			getSignData() {

				const that = this;
				var postUrl = 'WCF/WEB/svcZAD.svc/Get_ARRENDANCE_DATA';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: that.web_sphon, //web侧 登录ID  tihs.web_suuid
						sSAAID: that.query.valueSABSAAI, //幼儿ID
						sSTDT: this.dateFormat(that.query.start), //开始时间
						sENDT: this.dateFormat(that.query.end) //结束时间
					})
				.then((response) => {
					//请求成功返回的数据				
					let retSTR=response.data.KKSTR;

					if (retSTR == "N") {	
						this.$alert('没有满足条件的考勤数据', '提示', {
							confirmButtonText: '确定',
							callback: action => {}
						});
					} 
					else 
					{	
						this.$confirm('此操作将导出excel文件, 是否继续?', '提示', {
							confirmButtonText: '确定', //确定
							cancelButtonText: '取消', //取消
							type: 'warning'
						}).then(() => {		
							//下载excel
							let a = document.createElement('a')
								a.href = this.basehtmlURL + "EXCEL/" + retSTR
								a.click();		
						}).catch(() => {
							console.log('cancel'); //取消
						});	
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			}
		}
	};
</script>
<style scoped>
	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 12%;
	}


	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.select-shop {
		width: 16%;
	}

	.select-agent {
		width: 14%;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.handle-input {
		width: 220px;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
	}

	.el-upload--text {
		width: 140px;
		height: 80px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 140px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	.avatar {
		width: 140px;
		height: 80px;
		display: block;
	}

	.el-dialog__footer {
		text-align: center;
	}

	.dialog-footer-btn {
		margin-right: 20px;
	}

	.cropper {
		width: auto;
		height: 300px;
	}
</style>
